import { ResourcesConfig } from 'aws-amplify';

const userPoolId = import.meta.env.VITE_COGNITO_USER_POOL_ID;
const clientId = import.meta.env.VITE_COGNITO_CLIENT_ID;

export const isAwsAuth = !!(userPoolId && clientId);

const amplifyConfig: ResourcesConfig = isAwsAuth
    ? {
        Auth: {
            Cognito: {
                userPoolId,
                userPoolClientId: clientId,
            },
        },
    }
    : {};

export default amplifyConfig;
